var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVrio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 50,
    viewBox: "0 0 85 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6211 31.4479L5.27957 11.0391H0.398926L12.6033 37.7032C12.9645 38.4923 13.7529 38.9986 14.6207 38.9986C15.489 38.9986 16.2773 38.4923 16.6385 37.7032L28.8443 11.0391H23.9634L14.6211 31.4479Z",
    fill: "#2EB3C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9673 24.9792V38.9986H33.4051V24.9792C33.4051 19.7397 37.668 15.4769 42.9075 15.4769V11.0391C35.2208 11.0391 28.9673 17.2925 28.9673 24.9792Z",
    fill: "#2EB3C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.398926 38.9996H4.83691L0.398926 34.5615V38.9996Z",
    fill: "#2EB3C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8072 11.0391H47.3691V15.4772H51.8072V11.0391Z",
    fill: "#2EB3C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6369 34.5214C65.3756 34.5214 61.0952 30.241 61.0952 24.9797C61.0952 19.7185 65.3756 15.4381 70.6369 15.4381C75.898 15.4381 80.1787 19.7185 80.1787 24.9797C80.1787 30.241 75.898 34.5214 70.6369 34.5214ZM70.6369 11C62.916 11 56.6572 17.2588 56.6572 24.9797C56.6572 32.7005 62.916 38.9595 70.6369 38.9595C78.3576 38.9595 84.6166 32.7005 84.6166 24.9797C84.6166 17.2588 78.3576 11 70.6369 11Z",
    fill: "#2EB3C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 38.9593H51.8072V20.0244L47.3691 15.5908V38.9593Z",
    fill: "#2EB3C9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrio);
export default __webpack_public_path__ + "static/media/vrio.f5e467a68d318a651a653260f84a4c00.svg";
export { ForwardRef as ReactComponent };